const host = process.env.SERVER_HOST + (process.env.SERVER_PORT === '80' ? '' : ':' + process.env.SERVER_PORT)
const apiPath = host + '/api/'
// example
// export const API_GET_OMOIDE_UPLOAD = apiPath + '/GetOmoideUploadUrl'

export const API_LOGIN = apiPath + 'zengoweblogin'
export const API_LOGIN_FROM_APP = apiPath + 'loginfromapp'
export const API_LOGIN_FROM_APP_FOR_USER_INFO = apiPath + 'loginfromappforuserinfo'
export const API_LOGOUT = apiPath + 'zengoweblogout'
export const API_GET_USER_INFO = apiPath + 'getuserinfo'
export const API_CANCEL_CHARGE_PLAN = apiPath + 'cancelchargeplan'
export const API_REGISTER_PRE_USER_INFO = apiPath + 'registpreuserinfo'
export const API_UPDATE_USER_INFO = apiPath + 'updateuserinfo'
export const API_SEND_ZENGO_CONTACT = apiPath + 'sendzengocontact'
export const API_GET_PRE_USER_INFO = apiPath + 'getpreuserinfo'
export const API_REGIST_USER_INFO = apiPath + 'registuserinfo'
export const API_FORGOT_PASSWORD = apiPath + 'startupdatepassword';
export const API_RESET_PASSWORD = apiPath + 'updatepassword'
export const API_GET_RESET_PASSWORD = apiPath + 'getupdatepasswordinfo'
export const API_GET_LIST_CONSTRUCTION_SITE = apiPath + 'getconstructionsite'
export const API_ADD_CONSTRUCTION_USER = apiPath + 'addconstructionuser'
export const API_GET_PRE_CONSTRUCTION_USER_INFO = apiPath + 'getpreconstructionuserinfo'
export const API_SUBCRIBE_CHARGE_PLAN = apiPath + 'subscribechargeplan'
export const API_ADD_PRE_CONSTRUCTION_USER = apiPath + 'preaddconstructionuser'
export const API_DELETE_CONSTRUCTION_USER = apiPath + 'deleteconstructionuser'
export const API_GET_LIST_REPORT_LAYOUT = apiPath + 'getreportlayout'
export const API_MAKE_REPORT = apiPath + 'makereport'
export const API_MAKE_REPORT_V2 = apiPath + 'makereportv2'
export const API_DELETE_PROJECT = apiPath + 'deleteconstruction'
export const API_UPDATE_PROJECT = apiPath + 'saveconstructioninfo'
export const API_COPY_PROJECT = apiPath + 'copyconstruction'
export const API_GET_REPORT_LIST = apiPath + 'getreportlist'
export const API_DELETE_REPORT = apiPath + 'deletereport'
export const API_GET_CONSTRUCTION = apiPath + 'getconstruction'
export const API_MAKE_CONSTRUCTION = apiPath + 'makeconstruction'
export const API_UPDATE_EXPIRED_VIEW_AT = apiPath + 'updateexpiredviewatfromweb'
export const API_GET_INVOICE_REQUEST = apiPath + 'getinvoicerequest'
export const API_CHANGE_SINGLE_USER_INFO = apiPath + 'changesingleuserinfo'
export const API_CHANGE_PASSWORD = apiPath + 'changepassword'
export const API_SEND_MAIL_FOR_CHANGE_MAIL = apiPath + 'sendmailforchangemail'
export const API_CHANGED_EMAIL = apiPath + 'confirmchangemail'
export const API_GET_PRE_CONSTRUCTION_USER_LIST = apiPath + 'getpreconstructionuser'
export const API_DELETE_PRE_CONSTRUCTION_USER = apiPath + 'deletepreconstructionuser'
export const API_GET_REVIEWING_VERSIONS = apiPath + 'getreviewingversions'

export const API_MAKE_CONSTRUCTION_SITE = apiPath + 'makeconstructionsite'
export const API_SAVE_CONSTRUCTION_SITE = apiPath + 'saveconstructionsite'
export const API_DELETE_CONSTRUCTION_SITE = apiPath + 'deleteconstructionsite'
export const API_GET_IMAGE_UPLOAD_URL_FROM_WEB = apiPath + 'getimageuploadurlfromweb'
export const API_SAVE_ORDER_CONSTRUCTION_SITE_ID_LIST = apiPath + 'saveorderconstructionsiteidlist'
export const API_GET_NOTIFICATION = apiPath + 'getnotification'
export const API_GET_CONSTRUCTION_SITE_IMAGE = apiPath + 'getconstructionsiteimage'
export const API_COPY_CONSTRUCTION_IMAGE = apiPath + 'copyconstructionimage'
export const API_UPDATE_PAID_ACCOUNT_STATUS = apiPath + 'updatepaidaccountstatus'

export const API_GET_COMPANY_USER = apiPath + 'getcompanyuser'
export const API_ADD_COMPANY_USER = apiPath + 'addcompanyuser'
export const API_UPDATE_COMPANY_USER = apiPath + 'updatecompanyuser'
export const API_GET_COMPANY_CONSTRUCTION = apiPath + 'getcompanyconstruction'
export const API_UPDATEUSERSTOCONSTRUCTION = apiPath + 'updateuserstoconstruction'

export const API_RECORD_ACTION_LOG = apiPath + 'recordactionlog'
export const API_GET_ACTION_LOG = apiPath + 'app/getactionlog'



// WEBPACK FOOTER //
// ./src/configs/api.js